import React, { useEffect, useState } from "react";
import { shortDate, timeStamp } from "LIB/formatters/date";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import api from "APP_ROOT/api";
import { toastr } from "react-redux-toastr";

import { withRouter } from "react-router";
import { parse } from "query-string";
import { CONDITION, TAGGED_BY, TRACED_TO } from "MODULES/inventories/constants";
import { COST, QUANTITY } from "APP_ROOT/constants";
import { QUOTE_TYPE } from "MODULES/RepairQuotes/constants";
import { NO_QUOTE } from "MODULES/IncomingQuotes/constants";
import Form from "./Form";

function IncomingQuote(params) {
  const [incomingQuote, setIncomingQuote] = useState(null);
  const { id, c, no_quote: noQuote } = parse(params.location.search);

  useEffect(
    () => {
      if (!id) return Promise.resolve();

      api.incomingQuotes.customerFind(id, c).then(resp => {
        setIncomingQuote(resp.data);
      });

      return function cleanup() {};
    },
    [id]
  );

  if (!incomingQuote) return null;

  const quoted = !!incomingQuote.customer_submitted_at;

  return (
    <div>
      <h1 className="text-center">Request for Quote # {incomingQuote.code}</h1>
      {quoted && (
        <FormRow className="text-center">
          <h4 className="text-center">
            The RFQ above was completed on{" "}
            {shortDate(incomingQuote.customer_submitted_at)} at{" "}
            {timeStamp(incomingQuote.customer_submitted_at)}.
          </h4>
        </FormRow>
      )}
      <Form
        disabled={quoted}
        incomingQuote={incomingQuote}
        onSubmit={useOnSubmit(setIncomingQuote)}
        noQuote={noQuote}
        quoted={quoted}
        initialValues={{
          id,
          c,
          name: incomingQuote.contact.name,
          email: incomingQuote.contact.email,
          company_name: incomingQuote.company.name,
          phone1: incomingQuote.company.phone,
          line_items: incomingQuote.incoming_quote_line_items.map(i => {
            const noQuoted =
              noQuote && !quoted
                ? {
                    [CONDITION]: null,
                    [QUANTITY]: null,
                    [QUOTE_TYPE]: NO_QUOTE,
                    [CONDITION]: null,
                    [TAGGED_BY]: null,
                    [COST]: null,
                    [TRACED_TO]: null
                  }
                : {};

            return { ...i, ...noQuoted };
          })
        }}
      />
    </div>
  );
}

export default withRouter(IncomingQuote);

function buildAttachments(attachment = {}) {
  if (attachment.uploaded) {
    return Promise.resolve(attachment);
  }

  return new Promise((resolve, _) =>
    buildAttachmentFiles(attachment)
      .then(file => {
        resolve(file);
      })
      .catch(e => Promise.reject(e))
  );
}

function buildAttachmentFiles(attachment) {
  const fileName = `${+new Date() -
    Math.floor(Math.random() * 10000000000)}${attachment.file.name}`;
  return api.incomingQuotes.upload(fileName).then(resp => {
    const { key, url } = resp.data;
    const formattedAttachment = {
      attachment_type: attachment.attachment_type,
      name: fileName,
      key
    };
    return api.attachments
      .toS3(url, attachment.file)
      .then(() => Promise.resolve(formattedAttachment))
      .catch(e => Promise.reject(e));
  });
}

// Custom hooks
function useOnSubmit(setQuote) {
  const onSubmit = quote => {
    Promise.all(
      (quote.attachments || [])
        .map(attachment =>
          attachment.files.map(f => ({
            file: f,
            ...attachment
          }))
        )
        .flat()
        .map(buildAttachments)
    ).then(attachments => {
      const formattedData = Object.assign({}, quote, {
        attachments
      });
      api.incomingQuotes
        .customerUpdate(quote.id, formattedData)
        .then(resp => {
          setQuote(resp.data);
          toastr.success("Success", "Quote successfully sent.");
        })
        .catch(() => {
          toastr.error("Error", "An unexpected error occurred.");
        });
    });
  };

  return onSubmit;
}



// WEBPACK FOOTER //
// ./app/modules/Customers/IncomingQuote/IncomingQuote.jsx